/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { z } from "zod/v4";

export const headerProductStageDtoSchema = z.object({
  stage: z.optional(z.string()),
  description: z.optional(z.string()),
  status: z.optional(z.string()),
  deploymentStatus: z.optional(z.string()),
});
